// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flashlight';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.317 7.966 12.61 9.675a1.125 1.125 0 0 1-1.591 0L8.262 6.914a1.125 1.125 0 0 1 0-1.591l1.706-1.706a.563.563 0 0 1 .795 0l3.554 3.553a.564.564 0 0 1 0 .796z' />
    <path d='M11.09 9.743 3.913 16.92a1.126 1.126 0 0 1-1.592 0l-1.308-1.309a1.125 1.125 0 0 1 0-1.59l7.178-7.179M5.654 9.38l-.725-.725m9.509-5.159 1.687-1.688m-.562 3.375 1.687-.562m-4.5-2.251.563-1.687' />
  </g>
);

export const viewBox = '0 0 18 18';
